<template>
  <div class="bookArea">
    <bookItem
      @addexten="$emit('addexten')"
      :tabId="tabId"
      :pages="tabData.pages || []"
      :drawData="tabData.drawData"
      @toggleocr="toggleOCR"
      :mm="mm"
      :drawFs="drawFs"
      @print="emitPrint"
      @login="$emit('login')"
      :rotateImage="rotateImage"
    ></bookItem>
    <magnifyImg
      @dragging="doMag"
      v-if="showMagnify"
      :bookId="tabData.book"
      :page="magnifyPage"
      :magnifyPosition="magnifyPosition"
      :refresh="refresh"
      :imageRatio="imgRatio"
      :magRatio="1.5"
      :marginLeft="marginLeft"
    />
  </div>
</template>

<script>
import magnifyMix from "@/mixing/magnifier";
import magnifyImg from "./magnifyImg.vue";
import bookItem from "@/components/book/bookItem.vue";
export default {
  components: {
    bookItem,
    magnifyImg,
  },
  mixins: [magnifyMix],
  props: ["tabId", "tabData", "mm", "drawFs", "rotateImage"],
  computed: {
    book() {
      return this.tabData.book;
    },
    pages() {
      return this.tabData.pages;
    },
  },
  methods: {
    emitPrint(data) {
      this.$emit("print", data);
    },
    toggleOCR(show) {
      this.$emit("toggleocr", show);
    },
    doMag(x, y, e) {
      this.setMagnifyData(x, y, e, this.pages);
    },
  },
};
</script>

<style scoped>
body {
  direction: rtl;
  text-align: right;
}
.bookArea {
  position: relative;
  background-color: #f1f1f1;
}
</style>
